module.exports = __webpack_public_path__ + "static/media/img_oktocash.4ba46ea8.png";